import { DecimalPipe } from '@angular/common';
import { Component, inject, Input, OnInit, output } from '@angular/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { applyFastPaymentDiscount, ICompanyDocument } from '@okcargo-apps/shared-domain-ionic';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-fastpay-freight-card-cta',
  templateUrl: './fastpay-freight-card-cta.component.html',
  styleUrls: ['./fastpay-freight-card-cta.component.scss'],
  standalone: true,
  imports: [DecimalPipe, IonCardContent, IonButton, IonCardTitle, IonCardHeader, IonCard, TranslateModule],
})
export class FastpayFreightCardCtaComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);

  @Input()
  originalPrice!: number;

  @Input()
  freightId!: UUID;

  @Input()
  hasEnoughDocs!: boolean;

  @Input()
  expiredCompanyDocuments$!: Observable<ICompanyDocument[]>;

  public showModalFastPayment = output<void>();

  public priceWithDiscount: number | undefined;

  // constructor() {}

  ngOnInit(): void {
    const { priceWithDiscount } = applyFastPaymentDiscount(this.originalPrice);
    this.priceWithDiscount = priceWithDiscount;
  }

  public showFastpayRequestModalInParent(): void {
    this.showModalFastPayment.emit();
  }
}
